import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <div style={{ maxWidth: `300px`, marginBottom: `1.45rem` }}>
    Coming Soon!
    </div>
    <Link to="/etc-vr-setup/">ETC VR Workshop Setup</Link>
  </Layout>
)

export default IndexPage
